import en from './en';
import id from './id';

export default {
  en,
  id,
};
